import React from 'react';
import { RouteScanSummary } from '../../models/RouteScanSummary';
import { useNavigate } from "react-router-dom";

function RouteScanSummaryView({ routeScanSummary }: { routeScanSummary: RouteScanSummary }) {

    const navigate = useNavigate();

    const handleRouteClick = () => {
        navigate("/route/" + routeScanSummary.routeNumber);
    }

    return (
        <div className="grid grid-cols-6 text-center bg-white text-black">
            <div className="col-span-2 border-2 cursor-pointer hover:bg-blue-400" onClick={handleRouteClick}> {routeScanSummary.routeNumber} </div>
            <div className="col-span-1 border-2 bg-green-500"> {routeScanSummary.greenScans} </div>
            <div className="col-span-1 border-2 bg-yellow-300"> {routeScanSummary.yellowScans} </div>
            <div className="col-span-1 border-2 bg-red-600"> {routeScanSummary.redScans} </div>
            <div className="col-span-1 border-2"> {routeScanSummary.assignedParcels} </div>
        </div>
    )

}

export default RouteScanSummaryView;